import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { ElementRef, forwardRef, Renderer2 } from '@angular/core';
import { WRxBase } from './w-rx-base';
type AnyVoid = (_: any) => void;
export abstract class ValueAccessor extends WRxBase implements ControlValueAccessor {
  // tslint:disable-next-line: variable-name
  protected abstract _renderer: Renderer2;
  // tslint:disable-next-line: variable-name
  protected abstract _elementRef: ElementRef;

  // tslint:disable-next-line: variable-name
  _value: any = '';

  changeHandlers = [] as AnyVoid[];
  get value(): any {
    return this._value;
  }
  set value(v: any) {
    if (v !== this._value) {
      this._value = v;
      this.onChange(v);
    }
  }

  writeValue(value: any) {
    this.value = value;
  }

  onChange(_: any) {
    this.changeHandlers.forEach(h => {
      h.call(this, _);
    });
  }
  onTouched = () => { };
  registerOnChange(fn: AnyVoid): void {
    this.changeHandlers.push(fn);
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
  protected setProperty(key: string, value: any): void {
    this._renderer.setProperty(this._elementRef.nativeElement, key, value);
  }
  protected getProperty(key: string): any {
    return this._elementRef.nativeElement[key];
  }
  setDisabledState(isDisabled: boolean): void {
    this.setProperty('disabled', isDisabled);
  }
}
export function CreateControlAccessProvider(type: any) {
  return {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => type),
    multi: true
  };
}
